module.exports = __webpack_public_path__ + "static/media/24-3.8b11a24e.mp3";